// extracted by mini-css-extract-plugin
module.exports =  {"close":"a10a3f92e9--close--v38Z9"};